import Model from '../utils/Model'
import $store from '@/store'

/**
 * 状态类
 */
class BookingTerm {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'BookingTerm'
export const CODE_NAME_SEA = 'BookingTermSEA'

/**
 * 自订舱(SB).Only for Air.
 */
export const SB_BOOKING_TYPE = new BookingTerm('SB', 'Self Booking', '自订舱')
/**
 * 委托订舱(DB).Only for Air.
 */
export const DB_BOOKING_TYPE = new BookingTerm('DB', 'Delegation Booking', '委托订舱')
/**
 * 客户自订舱(CB).Only for Air.
 */
export const CB_BOOKING_TYPE = new BookingTerm('CB', 'Customer Booking', '客户自订舱')
/**
 * 自有约价(OS).Only for Sea.
 */
export const OS_BOOKING_TYPE = new BookingTerm('OS', 'OWN S/C', '自有约价')
/**
 * 客户约价(CS).Only for Sea.
 */
export const CS_BOOKING_TYPE = new BookingTerm('CS', 'CUSTOMER S/C', '客户约价')
/**
 * 海外代理约价(AS).Only for Sea.
 */
export const AS_BOOKING_TYPE = new BookingTerm('AS', 'O.AGENT S/C', '海外代理约价')
/**
 * 无约价(NS).Only for Sea.
 */
export const NS_BOOKING_TYPE = new BookingTerm('NS', 'NO.S/C', '无约价')
/**
 * 同行约价(NS).Only for Sea.
 */
export const BOOKING_TERM_PS = new BookingTerm('PS', 'Peer S/C', '同行约价')
/**
 * BUYER拼箱(BC)
 */
export const BC_BOOKING_TYPE = new BookingTerm('BC', 'Buyer Consolidation', 'BUYER拼箱')
/**
 * AFC约价
 */
export const BOOKING_TERM_AFC = new BookingTerm('AFC', 'AFC.S/C', 'AFC约价')
/**
 * AFG约价
 */
export const BOOKING_TERM_AFG = new BookingTerm('AFG', 'AFG.S/C', 'AFG约价')

export const BOOKING_TERMS = new Set([SB_BOOKING_TYPE, DB_BOOKING_TYPE, CB_BOOKING_TYPE])//, BC_BOOKING_TYPE
export const BOOKING_TERMS_SEA = new Set([OS_BOOKING_TYPE, CS_BOOKING_TYPE, AS_BOOKING_TYPE, BOOKING_TERM_PS, NS_BOOKING_TYPE, BOOKING_TERM_AFC, BOOKING_TERM_AFG])
export const BOOKING_TERMS_ALL = new Set([SB_BOOKING_TYPE, DB_BOOKING_TYPE, CB_BOOKING_TYPE, OS_BOOKING_TYPE, CS_BOOKING_TYPE, AS_BOOKING_TYPE, BOOKING_TERM_PS, NS_BOOKING_TYPE])

/**
 * 根据code获取 CommonState 的name
 * @param items
 * @param code
 */
export function getNameByCode(items, code, lang) {
  const valueType = Object.prototype.toString.call(items)
  lang = lang || $store.getters.language
  const filedName = lang === 'zh' ? 'chineseName' : 'englishName'
  let tempItems = []
  switch (valueType) {
    case '[object Array]':

      break
    case '[object Set]':
      tempItems = [...items]
      break
    case '[object CommonState]':
      tempItems = [items]
      break
  }
  const findItem = tempItems.find(item => {
    return item.code === code
  })

  return findItem ? findItem[filedName] : ''
}

/**
 *  return null:没找到.
 */

export function getBookingTypeByCode(code) {
  return Model.getObjByCode(code, BOOKING_TERMS)
}

export function getBookingTypeOfSeaByCode(code) {
  return Model.getObjByCode(code, BOOKING_TERMS_SEA)
}
